import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ca8f2522&scoped=true&"
import script from "./js/Index.js?vue&type=script&lang=js&"
export * from "./js/Index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=ca8f2522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8f2522",
  null
  
)

export default component.exports